import Icon from "@ant-design/icons";

export const FlagIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.75 3.76562H8.75V2C8.75 1.72344 8.52656 1.5 8.25 1.5H1.875V0.875C1.875 0.80625 1.81875 0.75 1.75 0.75H0.875C0.80625 0.75 0.75 0.80625 0.75 0.875V13.125C0.75 13.1938 0.80625 13.25 0.875 13.25H1.75C1.81875 13.25 1.875 13.1938 1.875 13.125V9H5.75V10.7656C5.75 11.0422 5.97344 11.2656 6.25 11.2656H12.75C13.0266 11.2656 13.25 11.0422 13.25 10.7656V4.26562C13.25 3.98906 13.0266 3.76562 12.75 3.76562ZM1.875 7.875V2.625H7.625V7.875H1.875ZM12.125 10.1406H6.875V9H8.625C8.69375 9 8.75 8.94375 8.75 8.875V4.89062H12.125V10.1406Z"
          fill="currentColor"
        />
      </svg>
    )}
    {...props}
  />
);

export const BiodiversityIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99967 13.6666C6.07745 13.6666 5.21079 13.4916 4.39967 13.1416C3.58856 12.7916 2.88301 12.3166 2.28301 11.7166C1.68301 11.1166 1.20801 10.4111 0.858008 9.59998C0.508008 8.78887 0.333008 7.9222 0.333008 6.99998C0.333008 6.07776 0.508008 5.21109 0.858008 4.39998C1.20801 3.58887 1.68301 2.88331 2.28301 2.28331C2.88301 1.68331 3.58856 1.20831 4.39967 0.858313C5.21079 0.508313 6.07745 0.333313 6.99967 0.333313C7.9219 0.333313 8.78856 0.508313 9.59968 0.858313C10.4108 1.20831 11.1163 1.68331 11.7163 2.28331C12.3163 2.88331 12.7913 3.58887 13.1413 4.39998C13.4913 5.21109 13.6663 6.07776 13.6663 6.99998C13.6663 7.9222 13.4913 8.78887 13.1413 9.59998C12.7913 10.4111 12.3163 11.1166 11.7163 11.7166C11.1163 12.3166 10.4108 12.7916 9.59968 13.1416C8.78856 13.4916 7.9219 13.6666 6.99967 13.6666ZM6.99967 12.3333C8.48856 12.3333 9.74967 11.8166 10.783 10.7833C11.8163 9.74998 12.333 8.48887 12.333 6.99998C12.333 6.9222 12.3302 6.84165 12.3247 6.75831C12.3191 6.67498 12.3163 6.60554 12.3163 6.54998C12.2608 6.8722 12.1108 7.13887 11.8663 7.34998C11.6219 7.56109 11.333 7.66665 10.9997 7.66665H9.66634C9.29967 7.66665 8.98579 7.53609 8.72468 7.27498C8.46356 7.01387 8.33301 6.69998 8.33301 6.33331V5.66665H5.66634V4.33331C5.66634 3.96665 5.7969 3.65276 6.05801 3.39165C6.31912 3.13054 6.63301 2.99998 6.99967 2.99998H7.66634C7.66634 2.74442 7.73579 2.51942 7.87467 2.32498C8.01356 2.13054 8.18301 1.9722 8.38301 1.84998C8.16079 1.79442 7.93579 1.74998 7.70801 1.71665C7.48023 1.68331 7.24412 1.66665 6.99967 1.66665C5.51079 1.66665 4.24967 2.18331 3.21634 3.21665C2.18301 4.24998 1.66634 5.51109 1.66634 6.99998H4.99967C5.73301 6.99998 6.36079 7.26109 6.88301 7.78331C7.40523 8.30554 7.66634 8.93331 7.66634 9.66665V10.3333H5.66634V12.1666C5.88856 12.2222 6.10801 12.2639 6.32467 12.2916C6.54134 12.3194 6.76634 12.3333 6.99967 12.3333Z"
          fill="currentColor"
        />
      </svg>
    )}
    {...props}
  />
);

export const HumanHealthIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 12C3.81111 12 3.65278 11.9361 3.525 11.8083C3.39722 11.6806 3.33333 11.5222 3.33333 11.3333V8.66667H0.666667C0.477778 8.66667 0.319444 8.60278 0.191667 8.475C0.0638889 8.34722 0 8.18889 0 8V4C0 3.81111 0.0638889 3.65278 0.191667 3.525C0.319444 3.39722 0.477778 3.33333 0.666667 3.33333H3.33333V0.666667C3.33333 0.477778 3.39722 0.319444 3.525 0.191667C3.65278 0.0638889 3.81111 0 4 0H8C8.18889 0 8.34722 0.0638889 8.475 0.191667C8.60278 0.319444 8.66667 0.477778 8.66667 0.666667V3.33333H11.3333C11.5222 3.33333 11.6806 3.39722 11.8083 3.525C11.9361 3.65278 12 3.81111 12 4V8C12 8.18889 11.9361 8.34722 11.8083 8.475C11.6806 8.60278 11.5222 8.66667 11.3333 8.66667H8.66667V11.3333C8.66667 11.5222 8.60278 11.6806 8.475 11.8083C8.34722 11.9361 8.18889 12 8 12H4ZM4.66667 10.6667H7.33333V7.33333H10.6667V4.66667H7.33333V1.33333H4.66667V4.66667H1.33333V7.33333H4.66667V10.6667Z"
          fill="currentColor"
        />
      </svg>
    )}
    {...props}
  />
);

export const ResourceScarcityIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7261 17.7583V19.5658H2.45884V17.7583H18.7261ZM18.7261 12.7057H14.8649C14.8585 12.7067 14.8393 12.7117 14.8066 12.7304C14.7541 12.7604 14.6851 12.8173 14.6213 12.9042C14.2805 13.3687 13.7888 13.9531 13.1598 14.4408C12.5361 14.9244 11.6555 15.406 10.573 15.4372C9.41493 15.4705 8.48346 14.7622 8.00216 14.3463C7.42743 13.8497 6.92479 13.2549 6.57683 12.8072C6.54115 12.7612 6.50326 12.7327 6.47534 12.718C6.45735 12.7086 6.44675 12.7061 6.44357 12.7057H2.45884V19.5658L2.27438 19.556C1.42353 19.4698 0.747438 18.7936 0.661075 17.9427L0.651367 17.7583V12.7057C0.651367 11.7074 1.4606 10.8982 2.45884 10.8982H6.44357L6.5583 10.9017C7.12843 10.9381 7.65043 11.243 8.00392 11.6978C8.59776 12.4619 9.54986 13.5137 10.3612 13.6218L10.521 13.6306C11.5095 13.6021 12.3547 12.8439 12.933 12.1338L13.1642 11.8346C13.5669 11.286 14.1844 10.8983 14.8649 10.8982H18.7261C19.7243 10.8982 20.5335 11.7074 20.5335 12.7057V17.7583L20.5238 17.9427C20.4375 18.7936 19.7614 19.4698 18.9105 19.556L18.7261 19.5658V12.7057Z"
          fill="currentColor"
        />
        <path
          d="M1.40743 4.34426C1.75555 3.98686 2.3278 3.97877 2.68537 4.32661L5.95788 7.5144L6.02054 7.58235C6.31468 7.93348 6.30113 8.45714 5.97465 8.79233C5.64816 9.12737 5.12511 9.15473 4.76643 8.87L4.69671 8.8091L1.42508 5.6222L1.36154 5.55424C1.06744 5.20327 1.08132 4.6795 1.40743 4.34426ZM16.0764 8.71997C15.7211 9.07054 15.149 9.06638 14.7984 8.71114C14.4479 8.3559 14.4512 7.78379 14.8064 7.4332L16.0764 8.71997ZM18.0365 4.2463C18.3917 3.89581 18.9639 3.89912 19.3144 4.25424C19.665 4.6095 19.6609 5.18248 19.3056 5.53306L16.0764 8.71997L14.8064 7.4332L18.0365 4.2463ZM9.5234 5.86667V1.31975C9.5234 0.820632 9.92801 0.416016 10.4271 0.416016C10.9262 0.416099 11.3309 0.820683 11.3309 1.31975V5.86667C11.3309 6.36574 10.9262 6.77032 10.4271 6.7704C9.92801 6.7704 9.5234 6.36579 9.5234 5.86667Z"
          fill="currentColor"
        />
      </svg>
    )}
    {...props}
  />
);
